import { factory } from '@store/utils'

const modalFactory = factory(() => ({
  actions: [],
  icon: null,
  name: '',
  show: false,
  text: '',
  theme: null,
  typeConfirm: null,
  template: null,
  isNested: false,
}))()

export default {
  store: {
    state: {
      modal: modalFactory(),
    },
    actions: {
      PROMPT({ dispatch }, { confirmTheme = 'danger', ...modal }) {
        dispatch('SHOW_MODAL', {
          actions: [
            {
              action: 'close',
              theme: 'neutral',
              label: 'No',
            },
            {
              action: 'confirm',
              theme: confirmTheme,
              label: 'Yes',
            },
          ],
          ...modal,
        })
      },
      PROMPT_DELETE({ dispatch }, { confirm, name }) {
        dispatch('PROMPT', {
          confirm,
          text: `Are you sure you want to delete this ${name}?`,
          typeConfirm: 'delete',
        })
      },
      SHOW_MODAL: ({ commit }, modal) => {
        commit('ADD_MODAL', { show: true, ...modal })
      },
      CLOSE_MODAL({ commit }) {
        commit('CLOSE_MODAL')
      },
    },
    mutations: {
      ADD_MODAL(state, modal) {
        state.modal = modalFactory(modal)
      },
      CLOSE_MODAL(state) {
        state.modal.show = false
      },
    },
    getters: {
      modal: state => state.modal,
    },
  },
}
